export const UPDATE_CURRENT_ROUTE = 'UPDATE_CURRENT_ROUTE';

export function updateCurrentRoute(route) {
  return {
    type: UPDATE_CURRENT_ROUTE,
    currentRoute: route,
  };
}
